import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm} from 'redux-form';
import validate from './validate';
import {renderField, renderSelect, renderTextarea} from '../../../utils/renderFields';
import { submitContactUs } from '../../../actions/globalConfig';

const propTypes = {
  removeModal: PropTypes.func,
}

const defaultProps = {
  removeModal: () => {},
}

class ContactUsForm extends React.Component {

  constructor(props){
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit(values) {
    return this.props.dispatch(submitContactUs(values, this.props.removeModal));
  }

  render(){
    const { error, handleSubmit, submitting, submitSucceeded } = this.props;
    const options = [
      {value: "general-inquiries", label: 'General Inquiries'},
      {value: "feedback-suggestions", label: 'Feedback / Suggestions'},
      {value: "internships", label: 'Internships'},
      {value: "jobs", label: 'Jobs'},
      {value: "partnerships", label: 'Partnerships'},
      {value: "press-inquires", label: 'Press Inquiries'},
      {value: "research", label: 'Research'},
    ];
    return (submitSucceeded) ? (<div className="text-center">Thanks for contacting Explore!</div>) : (
      <form onSubmit={handleSubmit(this.submit)}>
          <span className={error ? 'has-danger' : ''}>
            <span className="u-fontSize-11 form-control-feedback">{error}</span>
          </span>
        <Field component={renderField} name="name" type="text" label="Name" className="form-control" />
        <Field component={renderField} name="email" type="email" label="Email" className="form-control" />
        <Field component={renderSelect} name="reason" label="What's your reason for contacting us?" options={options} className="form-control" />
        <Field component={renderTextarea} name="body" label="Share your thoughts." className="form-control" />

        <div className="d-flex justify-content-between">
          <div><button className="btn btn-cancel" onClick={(e)=>{this.props.removeModal(e)}}>Cancel</button></div>
          <div><input type="submit" value="Submit" id="submit" className="btn btn-primary" disabled={submitting} /></div>
        </div>
      </form>
    );

  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    removeModal: ownProps.removeModal,
  }
}
ContactUsForm = reduxForm({form:'contact-us', validate, fields:['email','password','remember_me']})(ContactUsForm);

ContactUsForm.propTypes = propTypes;
ContactUsForm.defaultProps = defaultProps;

export default connect(mapStateToProps)(ContactUsForm);
